import React from 'react';

const SidebarTabs = ({ activeTab, onChange }) => (
  <div className="sidebar-tabs">
    <button
      type="button"
      className={`sidebar-tab ${activeTab === 'sites' ? 'active' : ''}`}
      onClick={() => onChange('sites')}
    >
      Sites
    </button>
    <button
      type="button"
      className={`sidebar-tab ${activeTab === 'jobs' ? 'active' : ''}`}
      onClick={() => onChange('jobs')}
    >
      Jobs
    </button>
  </div>
);

export default SidebarTabs;
